export const difference = (a, b) => {
    try {
        return a.difference(b);
    }
    catch {
        const difference = new Set(a);
        for (const o of b) {
            difference.delete(o);
        }
        return difference;
    }
};
export const symmetricDifference = (setA, setB) => {
    try {
        return setA.symmetricDifference(setB);
    }
    catch {
        const _difference = new Set(setA);
        for (const elem of setB) {
            if (_difference.has(elem)) {
                _difference.delete(elem);
            }
            else {
                _difference.add(elem);
            }
        }
        return _difference;
    }
};
export const hasSymmetricDifference = (setA, setB) => {
    const _difference = new Set(setA);
    for (const elem of setB) {
        if (_difference.has(elem)) {
            _difference.delete(elem);
        }
        else {
            return true;
        }
    }
    return _difference.size > 0;
};
//# sourceMappingURL=diffSet.js.map